(function () {
	'use strict';

    const module = angular.module('imApp');

    module.component('capTasksView', {
        templateUrl: 'views/components/views/capTasksView/capTasksView.template.html?v=' + module.version,
		controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'capTasksViewService', function ($stateParams, utilityService, capTasksViewService) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            vm.model = {
                setting: {},
                capTasksViewSetup: {
                    //date_fom: (new Date(y, m, f, 2)).toISOString().substring(0, 10),
                    date_fom: (new Date(2020, 5, 17, 2)).toISOString().substring(0, 10),
                    selectedview: 'timeline',
                    portal_user_keyno: '1',
                    templateStyle: 'alt',
                    //colorByGroup: false
                    functions: [
                        { name: 'add', func: function (data) { schedulerFunctions(this.name, data); } },
                        { name: 'update', func: function (data) { schedulerFunctions(this.name, data); } },
                        { name: 'delete', func: function (data) { schedulerFunctions(this.name, data); } },
                        { name: 'newDate', func: function (data) { schedulerFunctions(this.name, data); } }
                    ]
                },
                testSelect: null,
                test: [],
                tasksList: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region SCHEDULER FUNCTIONS
            
            var schedulerFunctions = function (name, data) {
                switch (name) {
                    case 'add':
                        break;
                    case 'update':
                        capTasksViewService.updateMovedItem(data).then(function () {
                            loadCapTasksViews();
                        });
                        break;
                    case 'delete':
                        break;
                    case 'newDate':
                        vm.model.setting.date_fom = data.fom;
                        vm.model.setting.date_tom = data.tom;//.toISOString().substring(0, 10);
                        vm.model.setting.selectedview = data.view;
                        break;
                    default:
                        break;
                }
            };

            // #endregion SCHEDULER FUNCTIONS

            // #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await capTasksViewService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }))[0];

                if (vm.model.setting.date_fom) {
                    vm.model.capTasksViewSetup.date_fom = vm.model.setting.date_fom;
                }

                if (vm.model.setting.selectedview) {
                    vm.model.capTasksViewSetup.selectedview = vm.model.setting.selectedview;
                }

                return loadCapTasksViews();
            }

            async function loadCapTasksViews() {
                if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

                vm.model.tasksList = [];

                vm.model.tasksList = (await capTasksViewService.listCapTasksViews({
                    argtype: vm.model.setting.argtype,
                    argvalue: vm.model.setting.argvalue
                }))[0];

                let toldDim = false;

                setTimeout(() => {
                    vm.model.tasksList.groups.forEach((item) => {
                        let containsItemDim = false;
                        let i = 0;

                        if (item && item.item_dim && item.item_dim !== '') {
                            for (i = 0; i < vm.model.test.length; i++) {
                                if (item.item_dim === vm.model.test[i].item_name) {
                                    containsItemDim = true;
                                    break;
                                }
                            }

                            if (!containsItemDim) {
                                vm.model.test.push({
                                    item_id: vm.model.test.length,
                                    item_name: item.item_dim
                                })
                            }
                        }

                        if (item.isgroup === 'false' && !toldDim) {
                            vm.onTestSelectChanged(i);
                            toldDim = true;
                        }
                    });
                }, 100);
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region ON TEST SELECT FUNCTION

            vm.onTestSelectChanged = function (value) {
                vm.model.testSelect = value;

                if (value) {
                    let currentDim = '';
                    let testItem = vm.model.test.find((item) => value === item.item_id);

                    if (testItem) currentDim = testItem.item_name;

                    vm.model.tasksList.forEach((item) => {
                        if (item && item.item_dim === currentDim) {
                            item.isgroup = false;
                        } else {
                            item.isgroup = true;
                        }
                    });
                }
            }

            // #endregion ON TEST SELECT FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
            }

            // #endregion ON INIT FUNCTION

		}]
	});
})();
